import type {Result, UseCase} from 'framework';
import type {AssistantAttachment} from '../../domain/assistant-attachment';
import type {AssistantError} from '../../domain/errors';
import type {AssistantRepository, UploadAttachmentInput} from '../ports/assistant.repository';

export class UploadAttachment implements UseCase<[UploadAttachmentInput], AssistantAttachment> {
  constructor(private readonly repository: AssistantRepository) {}

  execute(input: UploadAttachmentInput): Promise<Result<AssistantAttachment, AssistantError>> {
    return this.repository.uploadAttachment(input);
  }
}
